/**
 * marketingAttribution — shared client-side helper to read the persisted
 * ad-landing snapshot and fire conversion pings for downstream events
 * (PWA install, first offer activation, etc.). Best-effort — every call
 * silently no-ops if there's no attribution stored or the endpoint 404s.
 */
import api from "@/lib/api";

const STORAGE_KEY = "cyannect.ad_attribution";
const SEEN_KEY_PREFIX = "cyannect.ad_conv_fired.";

export function readAttribution() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.source) return null;
    // Expire attribution after 30 days
    if (parsed.ts && (Date.now() - parsed.ts) / 86400000 > 30) return null;
    return parsed;
  } catch { return null; }
}

/** Fire a conversion once per event_type per stored attribution snapshot. */
export function logAdConversion(eventType, extra = {}) {
  const attr = readAttribution();
  if (!attr) return; // organic visitor — nothing to attribute
  const key = SEEN_KEY_PREFIX + eventType + "." + (attr.ts || "0");
  try {
    if (localStorage.getItem(key)) return; // already fired
    localStorage.setItem(key, String(Date.now()));
  } catch {}
  api.post("/marketing/ad-conversion", {
    event_type: eventType,
    attribution: attr,
    extra,
  }).catch(() => {});
}
